export default __webpack_public_path__ + "static/media/Deathhand Bangles.a53ce023.jpg";